export default {
    chartTitle: 'factsheets_scene_deaths_chart_title',
    leftAxisLabel: 'factsheets_scene_deaths_chart_left_axis_label',
    rightAxisLabel: 'factsheets_scene_deaths_chart_right_axis_label',
};
